import React from 'react';

const maxWidthMap = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-3xl',
};

const ModalShell = ({
    isMounted,
    isOpen,
    onClose,
    children,
    maxWidth = 'md',
    className = '',
    contentClassName = '',
    bodyClassName = '',
    showCloseButton = true,
}) => {
    if (!isMounted) {
        return null;
    }

    return (
        <div
            className={`fixed inset-0 z-50 bg-black/50 transition-opacity duration-200 ${isOpen ? 'opacity-100' : 'opacity-0'}`}
            onClick={onClose}
        >
            <div className="flex min-h-full items-start justify-center p-3 sm:p-6">
                <div
                    className={`w-full ${maxWidthMap[maxWidth] || maxWidthMap.md} transform overflow-hidden rounded-[28px] border border-[#E5E8FB] bg-white shadow-xl transition-all duration-200 ${isOpen ? 'translate-y-0' : 'translate-y-2'} ${className}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className={`max-h-[calc(100vh-24px)] overflow-y-auto sm:max-h-[calc(100vh-48px)] ${contentClassName}`}>
                        {showCloseButton && (
                            <div className="flex justify-end px-4 pt-4 sm:px-5 sm:pt-5">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="inline-flex items-center rounded-lg bg-transparent p-1 text-black hover:bg-gray-200 hover:text-gray-900"
                                    aria-label="Close"
                                >
                                    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        )}
                        <div className={`px-4 pb-4 sm:px-5 sm:pb-5 ${bodyClassName}`}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalShell
